module.exports = __webpack_public_path__ + "static/SB-Logo-2026-Whte-1a9c374ae47ace88545c521dfed3a602.png";